const CREATIVE_SOLUTION_REGEX = /-(S\d+)(?:[_-]|$)/;

const parseSolutionFromCreative = (creative) => {
    if (!creative) return null;

    const match = creative.match(CREATIVE_SOLUTION_REGEX);

    return match ? match[1] : null;
};

export {
    parseSolutionFromCreative
};
